var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import * as dayjs from 'dayjs';
import { html, LitElement } from 'lit';
import css from './style.pcss';
import translations from './translations';
import CarteLux800Image from "./images/carte_lux_800px.png";
import CarteLux800NomImage from "./images/carte_lux_nom_800px.png";
import GustsOfWindEnImage from "./images/gustsofwind_en.png";
import GustsOfWindFrImage from "./images/gustsofwind_fr.png";
import GustsOfWindLuImage from "./images/gustsofwind_lu.png";
import RadarEnImage from "./images/radar_en.png";
import RadarFrImage from "./images/radar_fr.png";
import RadarLuImage from "./images/radar_lu.png";
import TotprecEnImage from "./images/totprec_en.png";
import TotprecFrImage from "./images/totprec_fr.png";
import TotprecLuImage from "./images/totprec_lu.png";
var TypeImages = {
  "gustsofwind": {
    "en": GustsOfWindEnImage,
    "fr": GustsOfWindFrImage,
    "lu": GustsOfWindLuImage
  },
  "radar": {
    "en": RadarEnImage,
    "fr": RadarFrImage,
    "lu": RadarLuImage
  },
  "totprec": {
    "en": TotprecEnImage,
    "fr": TotprecFrImage,
    "lu": TotprecLuImage
  }
};
var RTLMeteoRadar = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLMeteoRadar, _LitElement);
  function RTLMeteoRadar() {
    var _this;
    _classCallCheck(this, RTLMeteoRadar);
    _this = _callSuper(this, RTLMeteoRadar);
    _this.language = 'lu';
    _this.type = 'radar';
    _this.currentImage = "";
    _this.currentIndex = 0;
    _this.animation = false;
    _this.listener = false;
    _this.state = false;
    _this.notitle = false;
    _this.apis = {
      'radar': '/meteo/radar/radar.json',
      'sigweather': '/meteo/radar/sigweather.json',
      'totprec': '/meteo/radar/totprec.json',
      'gustsofwind': '/meteo/radar/gustsofwind.json'
    };
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
    }
    return _this;
  }
  _createClass(RTLMeteoRadar, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLMeteoRadar.prototype), "connectedCallback", this).call(this);
      this._fetchData();
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      var now = dayjs().format('HHmm');
      var url = this.apis[this.type];
      this.apiUrl = `https://static.rtl.lu${url}?v=${now}`;
      fetch(this.apiUrl).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;
        //this._startAnimation();
        _this2._preloadImages();
      });
    }
  }, {
    key: "_preloadImages",
    value: function _preloadImages() {
      var images = [];
      for (var i = 0; i < this.data.length; i++) {
        images[i] = new Image();
        images[i].src = this.data[i].url;
      }
    }
  }, {
    key: "_getTranslation",
    value: function _getTranslation(key) {
      if (!translations[key]) {
        console.warn(key + ' is not defined in translations.js!');
      } else return translations[key][this.language];
    }
  }, {
    key: "_getIndex",
    value: function _getIndex() {
      this.currentIndex >= this.data.length - 1 ? this.currentIndex = 0 : this.currentIndex = this.currentIndex + 1;
      var slider = this.shadowRoot.querySelector('.rtl-radar-nav__slider');
      slider.value = this.currentIndex;
      //console.log(this.currentIndex);
    }
  }, {
    key: "_setPlayState",
    value: function _setPlayState(state) {
      if (!this.state) {
        this._startAnimation();
      } else {
        this._stopAnimation();
      }
    }
  }, {
    key: "_startAnimation",
    value: function _startAnimation() {
      this.animation = setInterval(this._getIndex.bind(this), 200);
      this.state = true;
      var btn = this.shadowRoot.querySelector('.rtl-radar-nav__btn div');
      if (btn) btn.classList.add('paused');
    }
  }, {
    key: "_stopAnimation",
    value: function _stopAnimation() {
      clearInterval(this.animation);
      this.state = false;
      var btn = this.shadowRoot.querySelector('.rtl-radar-nav__btn div');
      if (btn) btn.classList.remove('paused');
    }
  }, {
    key: "_handleSlider",
    value: function _handleSlider(e) {
      this._stopAnimation();
      this.currentIndex = Number(e.target.value);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.data == undefined) return html(_t || (_t = _`<div class="rtl-meteo rtl-meteo--${0}"></div>`), this.type);
      return html(_t2 || (_t2 = _`
            <style>${0}</style>
            <div class="rtl-radar">
                ${0}
                <p class="rtl-radar__intro">${0}</p>
                <div class="rtl-radar-map">
                ${0}
                <img class="rtl-radar-map__overlay1" src="${0}" />
                <img class="rtl-radar-map__overlay2" src="${0}" />
                </div>
                <div class="rtl-radar-nav">
                    <div class="rtl-radar-nav__btn" @click=${0}>
                        <div></div>
                    </div>
                    <div class="rtl-radar-nav__slidercontainer">
                        <input type="range" min="0" max="${0}" @input="${0}" value="0" class="rtl-radar-nav__slider" id="animrange">
                    </div>
                    <div class="rtl-radar-nav__time">${0}</div>
                </div>
                <div class="rtl-radar-scale">
                    ${0}
                </div>
                <div class="rtl-radar__copyright">Source: <a href="https://kachelmannwetter.com/lu" target="_blank">https://kachelmannwetter.com/lu</a></div>
            </div>
        `), css, !this.notitle ? html(_t3 || (_t3 = _`<h3 class="rtl-radar__title">${0}</h3>`), this._getTranslation(this.type)) : '', this._getTranslation(this.type + '-descr'), this.currentIndex < this.data.length ? html(_t4 || (_t4 = _`<img class="rtl-radar-map__radar" src="${0}" />`), this.data[this.currentIndex].url) : ``, CarteLux800Image, CarteLux800NomImage, this._setPlayState, this.data.length - 1, this._handleSlider, dayjs.unix(this.data[this.currentIndex].ts).format("DD.MM.YYYY - HH:mm"), this.type == 'sigweather' ? html(_t5 || (_t5 = _`
                            <div class="rtl-radar-scale__sigweather">
                                <span style="background-color: #fdf733">${0}</span>
                                <span style="background-color: #c1bc29">${0}</span>
                                <span style="background-color: #43ff43">${0}</span>
                                <span style="background-color: #34c134">${0}</span>
                                <span style="background-color: #008200">${0}</span>
                                <span style="background-color: #8c8c8c">${0}</span>
                                <span style="background-color: #fd5fff">${0}</span>
                                <span style="background-color: #ba1abc">${0}</span>
                                <span style="background-color: #ffc189">${0}</span>
                                <span style="background-color: #ff973a">${0}</span>
                                <span style="background-color: #47f0ff">${0}</span>
                                <span style="background-color: #478cff">${0}</span>
                                <span style="background-color: #3568bd">${0}</span>
                                <span style="background-color: #ff4343">${0}</span>
                                <span style="background-color: #c80000">${0}</span>
                            </div>
                        `), this._getTranslation('fog'), this._getTranslation('fog hoarfrost'), this._getTranslation('rain light'), this._getTranslation('rain moderate'), this._getTranslation('rain heavy'), this._getTranslation('thunderstorm nearby'), this._getTranslation('thunderstorm light/moderate'), this._getTranslation('thunderstorm heavy'), this._getTranslation('sleet light'), this._getTranslation('sleet moderate/heavy'), this._getTranslation('snowfall light'), this._getTranslation('snowfall moderate'), this._getTranslation('snowfall heavy'), this._getTranslation('freezing rain light'), this._getTranslation('freezing rain moderate/heavy')) : html(_t6 || (_t6 = _`<img class="rtl-radar-scale__img" src="${0}" />`), TypeImages[this.type][this.language]));
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        type: {
          type: String
        },
        language: {
          type: String
        },
        currentIndex: {
          type: Number
        },
        notitle: {
          type: Boolean
        }
      };
    }
  }]);
  return RTLMeteoRadar;
}(LitElement);
export { RTLMeteoRadar as default };
window.customElements.define('rtl-meteo-radar', RTLMeteoRadar);